import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FigmaWizardComponent } from './components/figma-wizard/figma-wizard.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, FigmaWizardComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'design-to-code-guard';
}
